// Small dependency-free charts for the admin pages: one bar per day (or month), and shares.
import { number } from './adminFormat';

const short = (iso) => new Date(`${iso.length === 7 ? `${iso}-01` : iso}T00:00:00`)
  .toLocaleDateString('en-GB', iso.length === 7 ? { month: 'short' } : { day: 'numeric', month: 'short' });

export function Bars({ label, summary, rows, value, describe, keyOf = (row) => row.day }) {
  const max = Math.max(1, ...rows.map(value));
  const width = 100 / Math.max(rows.length, 1);
  return <figure className="adm-chart">
    <figcaption><span>{label}</span>{summary && <strong>{summary}</strong>}</figcaption>
    <svg viewBox="0 0 100 40" preserveAspectRatio="none" role="img" aria-label={`${label}${summary ? `: ${summary}` : ''}`}>
      <line x1="0" y1="39.8" x2="100" y2="39.8" />
      {rows.map((row, i) => {
        const height = (value(row) / max) * 38;
        return <rect key={keyOf(row)} x={i * width + width * 0.14} y={40 - height} width={width * 0.72} height={height}>
          <title>{describe(row)}</title>
        </rect>;
      })}
    </svg>
    {rows.length > 1 && <div className="adm-chart-axis" aria-hidden="true"><span>{short(keyOf(rows[0]))}</span><span>{short(keyOf(rows[rows.length - 1]))}</span></div>}
  </figure>;
}

export function Shares({ label, rows, total }) {
  const max = Math.max(1, ...rows.map((row) => row.value));
  return <figure className="adm-chart">
    <figcaption><span>{label}</span></figcaption>
    {rows.length === 0 ? <p className="adm-muted">No data yet.</p> : <ul className="adm-shares">
      {rows.map((row) => <li key={row.key}>
        <span className="adm-share-label">{row.label}</span>
        <span className="adm-share-track" aria-hidden="true"><span style={{ width: `${(row.value / max) * 100}%` }} /></span>
        <strong>{number(row.value)}{total ? <small> {Math.round((row.value / total) * 100)}%</small> : null}</strong>
        {row.note && <small className="adm-share-note">{row.note}</small>}
      </li>)}
    </ul>}
  </figure>;
}
